import { Match, Switch, createContext, createMemo, useContext } from "solid-js";
import styles from './st-icon.module.css';
import { transformImagePath } from "common";

class IconProps {
    src: string = '';
    size?: number = 16;
    tooltip?: string;
    spin?: boolean
}

export default function Icon(props: IconProps) {
    return <Switch>
        <Match when={props.src.startsWith('fa')}>
            <span class={`${styles.icon} ${props.src} ${props.spin ? 'fa-spin' : ''}`} role="presentation"></span>
        </Match>
        <Match when={props.src.includes('.svg')}>
            <img style={{ width: `${props.size ?? 16}px` }} class={styles.icon} src={transformImagePath(props.src)} />
        </Match>
        <Match when={!props.src}>
            &nbsp;
        </Match>
    </Switch>
}
Icon.defaultProps = new IconProps();
